import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'semantic-ui-react';
import { AboutMe, AboutMeDivider } from '../components/AboutMeSection';
import { Projects, ProjectsDivider } from '../components/Projects/';
import { Links, LinksDivider } from '../components/Links/';
import TopHeader from '../components/TopHeader/TopHeader';
import Footer from '../components/Footer/Footer';
import HomeIntro from '../components/Intro/HomeIntro';
import SEO from '../components/SEO/SEO';
import 'semantic-ui-less/semantic.less';
import '../style.css';

const HomeMeta = () => (
    <Helmet>
        <title>Yahia Bakour</title>
        <meta name="google-site-verification" content="b7wyoZNt_41S3Vs-OR319Y9f4ZHw6xtCZE8w1YPp-dM" />
        <meta name="description" content="Yahia Bakour's personal website. Yahia Bakour is a software engineer who enjoys solving problems and drinking nespresso." />
    </Helmet>
);

const Home = () => {
    return (
        <Container text>
            <HomeMeta />
            <SEO />
            <TopHeader />
            <br />
            <HomeIntro />
            <br /> <br />
            <br />
            <br />
            <ProjectsDivider />
            <Projects />
            <br />
            <LinksDivider />
            <Links />
            <br />
            <Footer />
        </Container>
    );
};

export default Home;
